import { useState, useEffect } from 'react';

export interface BrandSettings {
  logo?: string;
  primaryColor: string;
  secondaryColor: string;
  accentColor: string;
  backgroundColor: string;
  containerColor: string;
  textColor: string;
  cardBackgroundColor: string;
}

const DEFAULT_SETTINGS: BrandSettings = {
  primaryColor: '#3B82F6',
  secondaryColor: '#64748B',
  accentColor: '#F1F5F9',
  backgroundColor: '#FFFFFF',
  containerColor: '#F8FAFC',
  textColor: '#1E293B',
  cardBackgroundColor: '#FFFFFF',
};

const STORAGE_KEY = 'brandSettings';

export function useBrandSettings() {
  const [settings, setSettings] = useState<BrandSettings>(DEFAULT_SETTINGS);
  const [isLoading, setIsLoading] = useState(true);

  // Load settings from localStorage on mount
  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const parsedSettings = JSON.parse(stored);
        setSettings({ ...DEFAULT_SETTINGS, ...parsedSettings });
      }
    } catch (error) {
      console.error('Failed to load brand settings:', error);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Save settings to localStorage
  const saveSettings = (newSettings: BrandSettings) => {
    try {
      setSettings(newSettings);
      localStorage.setItem(STORAGE_KEY, JSON.stringify(newSettings));
    } catch (error) {
      console.error('Failed to save brand settings:', error);
    }
  };

  // Reset to default settings
  const resetSettings = () => {
    saveSettings(DEFAULT_SETTINGS);
  };

  return {
    settings,
    saveSettings,
    resetSettings,
    isLoading,
  };
}
